var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 5.09375H1.09375C0.919702 5.09375 0.752782 5.02461 0.629711 4.90154C0.50664 4.77847 0.4375 4.61155 0.4375 4.4375C0.4375 4.26345 0.50664 4.09653 0.629711 3.97346C0.752782 3.85039 0.919702 3.78125 1.09375 3.78125H12.9062C13.0803 3.78125 13.2472 3.85039 13.3703 3.97346C13.4934 4.09653 13.5625 4.26345 13.5625 4.4375C13.5625 4.61155 13.4934 4.77847 13.3703 4.90154C13.2472 5.02461 13.0803 5.09375 12.9062 5.09375Z",
    fill: "#494960"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 8.15625H3.28125C3.1072 8.15625 2.94028 8.08711 2.81721 7.96404C2.69414 7.84097 2.625 7.67405 2.625 7.5C2.625 7.32595 2.69414 7.15903 2.81721 7.03596C2.94028 6.91289 3.1072 6.84375 3.28125 6.84375H10.7188C10.8928 6.84375 11.0597 6.91289 11.1828 7.03596C11.3059 7.15903 11.375 7.32595 11.375 7.5C11.375 7.67405 11.3059 7.84097 11.1828 7.96404C11.0597 8.08711 10.8928 8.15625 10.7188 8.15625Z",
    fill: "#494960"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 11.2188H5.90625C5.7322 11.2188 5.56528 11.1496 5.44221 11.0265C5.31914 10.9035 5.25 10.7365 5.25 10.5625C5.25 10.3885 5.31914 10.2215 5.44221 10.0985C5.56528 9.97539 5.7322 9.90625 5.90625 9.90625H8.09375C8.2678 9.90625 8.43472 9.97539 8.55779 10.0985C8.68086 10.2215 8.75 10.3885 8.75 10.5625C8.75 10.7365 8.68086 10.9035 8.55779 11.0265C8.43472 11.1496 8.2678 11.2188 8.09375 11.2188Z",
    fill: "#494960"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ac45b172d72bb02e1b9ee8de11c1b508.svg";
export { ForwardRef as ReactComponent };